import Checkbox from "../../../../components/Checkbox";
import Input from "../../../../components/Inputs";
import Select from "../../../../components/Select";
import factoryFields from "../../../../helpers/factory-fields";
import { useAppSelector } from "../../../../hooks/useAppSelector";

const FormMonAnalogico = ({ handlerChange, filledStore }: any) => {
  const getGrupoMonitoramento = useAppSelector(
    (state) => state.getGrupoMonitoramento,
  );
  const dataEquipamentos = useAppSelector(
    (state) => state.equipamentos.dataEquipamentos,
  );
  const dataUnidadeDeMedida = useAppSelector(
    (state) => state.equipamentos.dataUnidadeDeMedida,
  );
  console.log(getGrupoMonitoramento, "getGrupoMonitoramento");
  return (
    <div
      className="container-fluid"
      style={{
        overflow: "hidden",
        maxHeight: "620px",
        marginBottom: "20px",
        overflowY: "auto",
      }}
    >
      <div className="row">
        <div className="col-sm-12 col-md-4">
          <h3 className="heading heading--sm text-secondary mb-20">
            Dados de endereçamento
          </h3>
          <Select
            onChange={handlerChange}
            name="idGrupoMonitor"
            value={filledStore?.idGrupoMonitor}
            options={
              getGrupoMonitoramento.status === "success"
                ? factoryFields.grupoMonitoramento(getGrupoMonitoramento?.data)
                : []
            }
            label="Grupo Monitoramento"
            size="sm"
          />
          <Select
            onChange={handlerChange}
            name="idEquipamento"
            value={filledStore?.idEquipamento}
            options={factoryFields.equipamentos(dataEquipamentos)}
            label="Equipamentos"
            size="sm"
          />
          <Input
            onChange={handlerChange}
            name="comentarios"
            value={filledStore?.comentarios}
            type="text"
            size="sm"
            label="Comentários"
          />
          <Input
            onChange={handlerChange}
            name="procedimento"
            value={filledStore?.procedimento}
            type="text"
            size="sm"
            placeholder="Ex: Calibração de medidor"
            label="Procedimento"
          />
          <Input
            onChange={handlerChange}
            name="descricao"
            value={filledStore?.descricao}
            type="text"
            size="sm"
            placeholder="Ex: Calibrar o medidor de temperatura"
            label="Descrição"
          />
        </div>
        <div className="col-sm-12 col-md-4">
          <h3 className="heading heading--sm text-secondary mb-20">
            Dados de medição
          </h3>
          <div className="row mb-20">
            <div className="col-12">
              <Select
                onChange={handlerChange}
                name="unidadeMedida"
                value={filledStore?.unidadeMedida}
                options={factoryFields.unidadesDeMedida(dataUnidadeDeMedida)}
                label="Unidades de medida"
                size="sm"
              />
            </div>
          </div>
          <div className="row mb-20">
            <div className="col-sm-12 col-md-6">
              <Input
                onChange={handlerChange}
                name="escalaInf"
                value={filledStore?.escalaInf}
                type="number"
                size="sm"
                label="Escala inferior"
              />
            </div>
            <div className="col-sm-12 col-md-6">
              <Input
                onChange={handlerChange}
                name="escalaSup"
                value={filledStore?.escalaSup}
                type="number"
                size="sm"
                label="Escala superior"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 col-md-6">
              <Input
                onChange={handlerChange}
                name="limiteInf"
                value={filledStore?.limiteInf}
                type="number"
                size="sm"
                label="Limite inferior"
              />
            </div>
            <div className="col-sm-12 col-md-6">
              <Input
                onChange={handlerChange}
                name="limiteSup"
                value={filledStore?.limiteSup}
                type="number"
                size="sm"
                label="Limite superior"
              />
            </div>
          </div>
        </div>
        <div
          className="col-sm-12 col-md-4"
          style={{
            maxHeight: "620px",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          <h3 className="heading heading--sm text-secondary mb-20">
            Dados de alerta e calibração
          </h3>
          <div className="row">
            <div className="col-6 mb-20">
              <Checkbox
                onChange={handlerChange}
                name="alertaAtivo"
                id="alertaAtivo"
                checked={filledStore?.alertaAtivo}
                label="Alerta ativo"
                size="sm"
              />
            </div>
            <div className="col-6">
              <Checkbox
                onChange={handlerChange}
                name="envioEmailAtivo"
                id="envioEmailAtivo"
                checked={filledStore?.envioEmailAtivo}
                label="Envio e-mail"
                size="sm"
              />
            </div>
            <div className="col-6">
              <Checkbox
                onChange={handlerChange}
                name="envioTelegramAtivo"
                id="envioTelegramAtivo"
                checked={filledStore?.envioTelegramAtivo}
                label="Envio telegram"
                size="sm"
              />
            </div>
          </div>
          <div className="row mb-20">
            <div className="col-6">
              <Checkbox
                onChange={handlerChange}
                name="envioWhatsAtivo"
                id="envioWhatsAtivo"
                checked={filledStore?.envioWhatsAtivo}
                label="Envio whatsApp"
                size="sm"
              />
            </div>
            <div className="col-6">
              <Checkbox
                onChange={handlerChange}
                name="planoAcaoAtivo"
                id="planoAcaoAtivo"
                checked={filledStore?.planoAcaoAtivo}
                label="Plano de ação"
                size="sm"
              />
            </div>
          </div>
          <Input
            onChange={handlerChange}
            name="toleranciaValor"
            value={filledStore?.toleranciaValor}
            type="number"
            label="Tolerancia valor"
            size="sm"
          />
          <Input
            onChange={handlerChange}
            name="toleranciaNormalizacao"
            value={filledStore?.toleranciaNormalizacao}
            type="number"
            placeholder="Ex.: 600 (10m)"
            label="Tempo de Estabilização para Normalização (seg)"
            size="sm"
          />
          <Input
            onChange={handlerChange}
            name="toleranciaTime"
            value={filledStore?.toleranciaTime}
            type="number"
            label="Tolerancia time (segs)"
            size="sm"
          />
          <div className="mb-20">
            <p className="mb-20">Horas para escalada NV2</p>
            <div className="row">
              <div className="col-sm-12 col-md-3">
                <Input
                  onChange={handlerChange}
                  name="hrMsgEscaladaNV2"
                  value={filledStore?.hrMsgEscaladaNV2}
                  type="text"
                  label="HH"
                  size="sm"
                />
              </div>
              <div className="col-sm-12 col-md-3">
                <Input
                  onChange={handlerChange}
                  name="minMsgEscaladaNV2"
                  value={filledStore?.minMsgEscaladaNV2}
                  type="text"
                  label="MM"
                  size="sm"
                />
              </div>
            </div>
          </div>
          <div className="mb-20">
            <p className="mb-20">Horas para escalada NV3</p>
            <div className="row">
              <div className="col-sm-12 col-md-3">
                <Input
                  onChange={handlerChange}
                  name="hrMsgEscaladaNV3"
                  value={filledStore?.hrMsgEscaladaNV3}
                  type="text"
                  label="HH"
                  size="sm"
                />
              </div>
              <div className="col-sm-12 col-md-3">
                <Input
                  onChange={handlerChange}
                  name="minMsgEscaladaNV3"
                  value={filledStore?.minMsgEscaladaNV3}
                  type="text"
                  label="MM"
                  size="sm"
                />
              </div>
            </div>
          </div>
          {/* <Input
            onChange={handlerChange}
            name="timeMsgEscaladaNV2"
            value={filledStore?.timeMsgEscaladaNV2}
            type="text"
            label="Horas para escalada NV2"
            size="sm"
          /> */}
          {/* <Input
            onChange={handlerChange}
            name="timeMsgEscaladaNV3"
            value={filledStore?.timeMsgEscaladaNV3}
            type="text"
            label="Horas para escalada NV3"
            size="sm"
          /> */}
          <Input
            onChange={handlerChange}
            name="coordX"
            value={filledStore?.coordX}
            type="number"
            label="Coordenada X"
            size="sm"
          />
          <Input
            onChange={handlerChange}
            name="coordY"
            value={filledStore?.coordY}
            type="number"
            label="Coordenada Y"
            size="sm"
          />
          <Input
            onChange={handlerChange}
            name="offSet"
            value={filledStore?.offSet}
            type="number"
            label="Offset"
            size="sm"
          />
          <Input
            onChange={handlerChange}
            name="calibracaoEscala"
            value={filledStore?.calibracaoEscala}
            type="number"
            label="Calibração escala"
            size="sm"
          />
        </div>
      </div>
    </div>
  );
};

export default FormMonAnalogico;
